import axios from "../config/axios";
import { useQuery } from "react-query";

// [7]
const getTableauRecordsByTableauId = async (tableau_id: any) => {
    // console.log("getTableauRecordsByTableauId", tableau_id)
  const res = await axios.GENERAL.get("/tableaurecords/by_tableau_id/"+tableau_id)
  if (res.status === 200) {
    console.log("getTableauRecordsByTableauId", res)
    return res.data
  }
}

// relation
// [15]
// INPUT
// school_id \ if null select All
// person_id\ if null select All
// region_id\ if null select All
const getTableaurecordsBySPR = async (query: any) => {
  const res = await axios.GENERAL.post("/tableaurecords/relation", query)
  if (res.status === 200) {
    console.log("getTableaurecordsBySPR", res);
    return res.data
  }
}

// [15-1]
const getTableaurecordsBySchoolId = async (school_id: string) => {
  const res = await axios.GENERAL.get("/tableaurecords/related_by_school/" + school_id)
  if (res.status === 200) {
    console.log("getTableaurecordsBySchoolId", res);
    return res.data
  }
}
// [15-2]
const getTableaurecordsByPersonId = async (person_id: string) => {
  const res = await axios.GENERAL.get("/tableaurecords/related_by_person/" + person_id)
  if (res.status === 200) {
    console.log("getTableaurecordsByPersonId", res)
    return res.data
  }
}
// [15-3]
const getTableaurecordsByRegionId = async (region_id: string) => {
  const res = await axios.GENERAL.get("/tableaurecords/related_by_region/" + region_id)
  if (res.status === 200) {
    console.log("getTableaurecordsByRegionId", res);
    return res.data
  }
}

export default {
  getTableauRecordsByTableauId,
  getTableaurecordsBySPR,
  getTableaurecordsBySchoolId,
  getTableaurecordsByPersonId,
  getTableaurecordsByRegionId
};